import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { Checkbox, Icon, Grid, Label, List, Loader, Dimmer, Form, Radio, Button } from 'semantic-ui-react'
import { connect } from 'react-redux';
import { MDBDataTable } from 'mdbreact';
import { fetchAllUsers, deleteUser, fetchAllSubmittedUsers } from '../../services/userService';
import { getAllRegisteredUsersError, getAllRegisteredUsers, getAllRegisteredUsersPending } from '../../reducers/AllRegisteredUsersReducer';
import { GetAllSubmittedEmployeesReportURL, GetEmployeeInformationURL, GetAllOfficeListingPointOfContactEmeaURL } from '../../constants';
import { store } from '../../indexApp.js';
import { bindActionCreators, compose } from 'redux';
import { Link } from 'react-router-dom';
import './AdminRegisteredUserPage.css';
import { authAxios } from '../../utils';
import { authContext, getToken } from '../../adalConfig';

var loginname = authContext.getCachedUser() ? authContext.getCachedUser().profile.upn : '';
let loginNameWithDomain = authContext.getCachedUser() ? authContext.getCachedUser().profile.upn : '';

class AdminReport extends Component {
    constructor(props) {
        super(props)
    }

    state = {
        data: [],
        dataEmea: [],
        dataNa: [],
        region: '',
        shippingInfo: []
    }

    getEmployeesData(employees) {
        if (employees && employees.length > 0) {
            let data = employees.map((x, index) => {
                return ({
                    'LOB': x.userRole,
                    'User_ID': x.loginName,
                    'Employee_Name': x.name,
                    'Email': x.email,
                    'JobFunction': x.jobFunction,
                    'Delivery_Office': x.deliveryOffice,
                    'Office_Code': x.officeCode,
                    'Cost_Center': x.costCenter,
                    'Country': x.country,
                    'Region': x.region,
                    'Upgrade_Date': x.upgradeWeek,
                    'Selected_Device': x.currentSelectedComputerDevice,
                    'Selected_Dock': x.currentSelectedDockDevice,
                    'User_Comments': this.isBase64(x.userComments) ? atob(x.userComments).replace(/(\r\n|\n|\r)/gm, " ") : x.userComments.replace(/(\r\n|\n|\r)/gm, " "),
                    'Optout_Comments': this.isBase64(x.optoutComments) ? atob(x.optoutComments).replace(/(\r\n|\n|\r)/gm, " ") : x.optoutComments.replace(/(\r\n|\n|\r)/gm, " "),
                    'Software_Packages': this.isBase64(x.softwarePackages) ? atob(x.softwarePackages) : x.softwarePackages,
                    'Registered': x.isSubmitted ? 'yes' : 'no',
                    'Optout': x.isOptout ? 'yes' : 'no',
                    'Upgrad_Deadline': x.isDeadline ? 'yes' : 'no',
                    'Reservation_Reminder': x.mondaySevenDaysReminderEmailFlag ? 'yes' : 'no',
                    'Complete_Your_Computer_Upgrade': x.thursdayPriorToUpgradeWeekFlag ? 'yes' : 'no',
                    'Shipping_Confirmation': x.fiveDaysTrackingEmailFlag ? 'yes' : 'no',
                    'Ship_Date': x.shipDate != null ? this.formatDate(x.shipDate) : null,
                    'Tracking_Number': x.trackingNumber,

                })
            });
            return data;
        }
        return [];
    }

    isBase64(str) {
        if (!str)
            return false;
        if (str === '' || str.trim() === '') { return false; }
        try {
            return btoa(atob(str)) == str;
        } catch (err) {
            return false;
        }
    }

    formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        return [month, day, year].join('/');
    }



    componentDidMount() {
        if (!loginname) {
            this.props.history.push('../../unauthorized');
        }

        authAxios.post(GetEmployeeInformationURL, {
            LoginNameWithDomain: loginNameWithDomain
        })
            .then(response => {
                let data = response.data
                this.setState({
                    region: data.region
                })
            })
            .catch((error) => {
                this.setState({ loading: false });
            })

        authAxios.get(GetAllSubmittedEmployeesReportURL)
            .then(response => {
                let allData = this.getEmployeesData(response.data);
                let dataEmea = allData.filter(item => item.Region && item.Region.toUpperCase() === 'EMEA');
                let dataNa = allData.filter(item => item.Region && item.Region.toUpperCase() === 'NA');
                this.setState({
                    data: allData,
                    dataEmea: dataEmea,
                    dataNa: dataNa,
                });
            });

        authAxios.get(GetAllOfficeListingPointOfContactEmeaURL)
            .then(response => {
                let shipping = response.data
                this.setState({
                    shippingInfo: shipping.shippingInfo
                });
            });

 
    }

    componentDidUpdate(prevProps, prevState) {
        //if (!this.props.registeredUsers || this.props.registeredUsers.length <= 0) return;
        if (this.props.registeredUsers != prevProps.registeredUsers) {
            this.setState({ data: this.getEmployeesData(this.props.registeredUsers) });
        }
        for (let i = 0; i < this.props.registeredUsers.length; i++) {
            if (this.props.registeredUsers != prevProps.registeredUsers) {
                this.setState({ data: this.getEmployeesData(this.props.registeredUsers) });
                break;
            }
            if (prevProps.registeredUsers.length > 0) {
                if (this.props.registeredUsers[i] && this.props.registeredUsers[i].computerDevices && this.props.registeredUsers[i].computerDevices.length != prevProps.registeredUsers[i].computerDevices.length) {
                    this.setState({ data: this.getEmployeesData(this.props.registeredUsers) });
                }
            }
        }
    }



    handleGoBackToWelcomePage = () => {
        this.props.history.push('/welcomepage')
    }

    handleCSVDownload = () => {
        let { dataNa } = this.state;
        const rows = [
            ["LOB", "User ID", "Employee Name", "Title", "Delivery Office", "Office Code", "Cost Center", "Email", "Upgrade Date", "Selected Device", "Selected Dock", "User Comments", "Optout Comments", "Software Packages", "Registered", "Optout", "Upgrade Deadline", "Reservation Reminder", "Complete Your Computer Upgrade", "Shipping Confirmation", "Ship Date", "Tracking Number", "Region"]
        ]
        for (let i = 0; i < dataNa.length; i++) {
            let row = [];
            row.push(dataNa[i].LOB);
            row.push(dataNa[i].User_ID);
            row.push(dataNa[i].Employee_Name);
            row.push(dataNa[i].JobFunction);
            row.push(dataNa[i].Delivery_Office);
            row.push(dataNa[i].Office_Code);
            row.push(dataNa[i].Cost_Center);
            row.push(dataNa[i].Email);
            row.push(dataNa[i].Upgrade_Date);
            row.push(dataNa[i].Selected_Device);
            row.push(dataNa[i].Selected_Dock);
            row.push(dataNa[i].User_Comments);
            row.push(dataNa[i].Optout_Comments);
            row.push(dataNa[i].Software_Packages);
            row.push(dataNa[i].Registered);
            row.push(dataNa[i].Optout);
            row.push(dataNa[i].Upgrad_Deadline);
            row.push(dataNa[i].Reservation_Reminder);
            row.push(dataNa[i].Complete_Your_Computer_Upgrade);
            row.push(dataNa[i].Shipping_Confirmation);
            row.push(dataNa[i].Ship_Date);
            row.push(dataNa[i].Tracking_Number);
            row.push(dataNa[i].Region);
            rows.push(row);
        }

        var Papa = require("papaparse/papaparse.min.js");
        var csv = Papa.unparse(rows);
        var csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        var csvURL = null;
        if (navigator.msSaveBlob) {
            csvURL = navigator.msSaveBlob(csvData, 'Report.csv');
        } else {
            csvURL = window.URL.createObjectURL(csvData);
        }
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', 'Report.csv');
        tempLink.click();

    }

    handleEmeaDownload = () => {
        let { dataEmea } = this.state;
            const rows = [
                ["LOB", "User ID", "Employee Name", "Email", "Title", "Delivery Office", "Office Code", "Cost Center", "Country", "Region", "Upgrade Date", "Selected Device", "Optout Comments", "Registered", "Optout", "Upgrade Deadline", "Reservation Reminder", "Complete Your Computer Upgrade"]
        ]
        for (let i = 0; i < dataEmea.length; i++) {
            let row = [];
            row.push(dataEmea[i].LOB);
            row.push(dataEmea[i].User_ID);
            row.push(dataEmea[i].Employee_Name);
            row.push(dataEmea[i].Email);
            row.push(dataEmea[i].JobFunction);
            row.push(dataEmea[i].Delivery_Office);
            row.push(dataEmea[i].Office_Code);
            row.push(dataEmea[i].Cost_Center);
            row.push(dataEmea[i].Country);
            row.push(dataEmea[i].Region);
            row.push(dataEmea[i].Upgrade_Date);
            row.push(dataEmea[i].Selected_Device);
            row.push(dataEmea[i].Optout_Comments);
            row.push(dataEmea[i].Registered);
            row.push(dataEmea[i].Optout);
            row.push(dataEmea[i].Upgrad_Deadline);
            row.push(dataEmea[i].Reservation_Reminder);
            row.push(dataEmea[i].Complete_Your_Computer_Upgrade);
            rows.push(row);
        }

        var Papa = require("papaparse/papaparse.min.js");
        var csv = Papa.unparse(rows);
        var csvData = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        var csvURL = null;
        if (navigator.msSaveBlob) {
            csvURL = navigator.msSaveBlob(csvData, 'emea_Report.csv');
        } else {
            csvURL = window.URL.createObjectURL(csvData);
        }
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', 'emea_Report.csv');
        tempLink.click();
    }

    handleEMEA() {
        if (this.state.region === 'EMEA') {
            return (
                <React.Fragment>
                    <Button style={{ margin: 5, backgroundColor: "#2185d0", color: "white" }} onClick={this.handleEmeaDownload}>EMEA Download CSV</Button>
                </React.Fragment>
            )
        }
    }

    handelNA() {
        if (this.state.region === 'NA') {
            return (
                <React.Fragment>
                    <Button style={{ margin: 5, backgroundColor: "#2185d0", color: "white" }} onClick={this.handleCSVDownload}>Download CSV</Button>
                </React.Fragment>
            )
        }
    }

    tableData = (region) => {
        const colunms = [
            {
                label: 'LOB',
                field: 'LOB',
                sort: 'asc',
                width: 70
            },
            {
                label: 'User ID',
                field: 'User_ID',
                sort: 'asc',
                width: 100
            },
            {
                label: 'Employee Name',
                field: 'Employee_Name',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Email',
                field: 'Email',
                sort: 'abd',
                width: 70
            },
            {
                label: 'Employee Title',
                field: 'JobFunction',
                sort: 'asc',
                width: 150
            },
            {
                label: 'Delivery Office',
                field: 'Delivery_Office',
                sort: 'asc',
                width: 100
            },
            {
                label: 'Office Code',
                field: 'Office_Code',
                sort: 'asc',
                width: 100
            },
            {
                label: 'Cost Center',
                field: 'Cost_Center',
                sort: 'asc',
                width: 70
            },
            {
                label: 'Country',
                field: 'Country',
                sort: 'asc',
                width: 70
            },
            {
                label: 'Upgrade Date',
                field: 'Upgrade_Date',
                sort: 'asc',
                width: 100
            },
            {
                label: 'Selected Device',
                field: 'Selected_Device',
                sort: 'asc',
                width: 100
            },
            {
                label: 'Selected Dock',
                field: 'Selected_Dock',
                sort: 'asc',
                width: 50
            },
            {
                label: 'User Comments',
                field: 'User_Comments',
                sort: 'asc',
                width: 100
            },
            {
                label: 'Optout Comments',
                field: 'Optout_Comments',
                sort: 'asc',
                width: 100
            },
            {
                label: 'Software Packages',
                field: 'Software_Packages',
                sort: 'asc',
                width: 100
            },
            {
                label: 'Registered',
                field: 'Registered',
                sort: 'asc',
                width: 100
            },
            {
                label: 'Optout',
                field: 'Optout',
                sort: 'asc',
                width: 100
            },
            {
                label: 'Upgrade Deadline',
                field: 'Upgrad_Deadline',
                sort: 'asc',
                width: 100
            },
            {
                label: 'Reservation Reminder',
                field: 'Reservation_Reminder',
                sort: 'asc',
                width: 100
            },
            {
                label: 'Complete Your Computer Upgrade',
                field: 'Complete_Your_Computer_Upgrade',
                sort: 'asc',
                width: 100
            },
            {
                label: 'Shipping Confirmation',
                field: 'Shipping_Confirmation',
                sort: 'asc',
                width: 100
            },
            {
                label: 'Ship Date',
                field: 'Ship_Date',
                sort: 'asc'
            },
            {
                label: 'Tracking Number',
                field: 'Tracking_Number',
                sort: 'asc',
                width: 100
            },
            {
                label: 'Region',
                field: 'Region',
                sort: 'asc',
                width: 70
            },
        ];
        let rows = [];
        if (region === 'NA') {
            rows = this.state.dataNa;
        } else if (region === 'EMEA') {
            rows = this.state.dataEmea;
        }
        return { colunms, rows };
    }

    handleNaReport() {
        if (this.state.region === 'NA') {
            return (
                <React.Fragment>
                    <div className="datatable-grid">
                        <MDBDataTable
                            responsive
                            striped
                            bordered
                            hover
                            data={this.tableData('NA')} />
                    </div>
                </React.Fragment>
            )
        }
    }

    handleEmeaReport() {
        if (this.state.region === 'EMEA') {
            return (
                <React.Fragment>
                    <div className="datatable-grid">
                        <MDBDataTable
                            responsive
                            striped
                            bordered
                            hover
                            data={this.tableData('EMEA')} />
                    </div>
                </React.Fragment>
            )
        }
    }

    render() {
        const tableData = {
            columns: [
                {
                    label: 'LOB',
                    field: 'LOB',
                    sort: 'asc',
                    width: 70
                },
                {
                    label: 'User ID',
                    field: 'User_ID',
                    sort: 'asc',
                    width: 100
                },
                {
                    label: 'Employee Name',
                    field: 'Employee_Name',
                    sort: 'asc',
                    width: 50
                },
                {
                    label: 'Email',
                    field: 'Email',
                    sort: 'abd',
                    width: 70
                },
                {
                    label: 'Employee Title',
                    field: 'JobFunction',
                    sort: 'asc',
                    width: 150
                },
                {
                    label: 'Delivery Office',
                    field: 'Delivery_Office',
                    sort: 'asc',
                    width: 100
                },
                {
                    label: 'Office Code',
                    field: 'Office_Code',
                    sort: 'asc',
                    width: 100
                },
                {
                    label: 'Cost Center',
                    field: 'Cost_Center',
                    sort: 'asc',
                    width: 70
                },
                {
                    label: 'Country',
                    field: 'Country',
                    sort: 'asc',
                    width: 70
                },
                {
                    label: 'Upgrade Date',
                    field: 'Upgrade_Date',
                    sort: 'asc',
                    width: 100
                },
                {
                    label: 'Selected Device',
                    field: 'Selected_Device',
                    sort: 'asc',
                    width: 100
                },
                {
                    label: 'Selected Dock',
                    field: 'Selected_Dock',
                    sort: 'asc',
                    width: 50
                },
                {
                    label: 'User Comments',
                    field: 'User_Comments',
                    sort: 'asc',
                    width: 100
                },
                {
                    label: 'Optout Comments',
                    field: 'Optout_Comments',
                    sort: 'asc',
                    width: 100
                },
                {
                    label: 'Software Packages',
                    field: 'Software_Packages',
                    sort: 'asc',
                    width: 100
                },
                {
                    label: 'Registered',
                    field: 'Registered',
                    sort: 'asc',
                    width: 100
                },
                {
                    label: 'Optout',
                    field: 'Optout',
                    sort: 'asc',
                    width: 100
                },
                {
                    label: 'Upgrade Deadline',
                    field: 'Upgrade_Deadline',
                    sort: 'asc',
                    width: 100
                },
                {
                    label: 'Reservation Reminder',
                    field: 'Reservation_Reminder',
                    sort: 'asc',
                    width: 100
                },
                {
                    label: 'Complete Your Computer Upgrade',
                    field: 'Complete_Your_Computer_Upgrade',
                    sort: 'asc',
                    width: 100
                },
                {
                    label: 'Shipping Confirmation',
                    field: 'Shipping_Confirmation',
                    sort: 'asc',
                    width: 100
                },
                {
                    label: 'Ship Date',
                    field: 'Ship_Date',
                    sort: 'asc'
                },
                {
                    label: 'Tracking Number',
                    field: 'Tracking_Number',
                    sort: 'asc',
                    width: 100
                },
                {
                    label: 'Region',
                    field: 'region',
                    sort: 'asc',
                    width: 70
                },


            ],
            rows: this.state.data
        };

        if (this.props.registeredPending)
            return (
                <div className="center-me">
                    <Dimmer active inverted>
                        <Loader size='huge'>Getting All The Employees...</Loader>
                    </Dimmer>
                </div>
            )
        return (
            <React.Fragment>
                {this.handelNA()}
                {this.handleEMEA()}
                {/*{this.handleNaReport()}*/}
                {/*{this.handleEmeaReport()}*/}

                <div className="datatable-grid">
                    <MDBDataTable
                        responsive
                        striped
                        bordered
                        hover
                        data={tableData} />
                </div>
                <Button
                    onClick={this.handleGoBackToWelcomePage}
                    className="welcome-page-back-buttonRegUsers">
                    Back
                </Button>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    error: getAllRegisteredUsersError(state),
    registeredUsers: getAllRegisteredUsers(state),
    registeredPending: getAllRegisteredUsersPending(state)

})

const mapDispatchToProps = dispatch => bindActionCreators({
    fetchAllSubmittedUsers: fetchAllSubmittedUsers,
    deleteUser: deleteUser
}, dispatch)

export default compose(withRouter,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ))(AdminReport);


